// Phase 85.A.358 — Đếm lượt xem ĐỒNG BỘ cho mọi loại video.
// Mỗi lần user BẤM xem = +1 view (KHÔNG dedupe theo user — cùng người bấm
// nhiều lần vẫn tăng). Gọi 1 endpoint duy nhất `/api/public/media-view`.
import { api } from "./api";
import { getTrafficFlag } from "./trafficFlags";

// v17.19 — Traffic control: tắt đếm lượt xem media trong trận.
function viewsDisabled() {
  try { return !getTrafficFlag("media_view_counter"); } catch { return false; }
}

// Suy ra media_kind từ 1 item bất kỳ (home highlight, recap, athlete video…).
export function mediaKindOf(item) {
  if (!item) return null;
  if (item.media_kind) return item.media_kind;
  if (item.is_recap || item.kind === "recap") return "recap";
  if (item.is_match_highlight || item.kind === "highlight") return "highlight";
  if (item.kind === "rating") return "rating";
  if (item.kind === "admin" || item.kind === "athlete") return "athlete";
  return null;
}

// Đăng ký 1 lượt xem cho video thường (highlight / recap / athlete / rating).
// Trả về view_count mới (hoặc null nếu lỗi) để caller cập nhật UI lạc quan.
export async function registerMediaView(item) {
  try {
    if (viewsDisabled()) return null;
    const kind = mediaKindOf(item);
    if (!kind || !item?.id) return null;
    const r = await api.post("/public/media-view", {
      media_kind: kind,
      media_id: item.id,
    });
    return typeof r?.data?.view_count === "number" ? r.data.view_count : null;
  } catch {
    return null;
  }
}

// Đăng ký lượt xem cho 1 VOD livestream (recording trong session).
export async function registerVodView({ session_id, recording_id, id }) {
  try {
    if (!session_id) return null;
    const r = await api.post("/public/media-view", {
      media_kind: "vod",
      media_id: recording_id || id,
      session_id,
      recording_id: recording_id || id,
    });
    return typeof r?.data?.view_count === "number" ? r.data.view_count : null;
  } catch {
    return null;
  }
}

// Đăng ký lượt xem cho 1 phiên livestream (trang xem live, top-level session).
export async function registerSessionView(sessionId) {
  try {
    if (!sessionId) return null;
    const r = await api.post("/public/media-view", {
      media_kind: "session",
      media_id: sessionId,
    });
    return typeof r?.data?.view_count === "number" ? r.data.view_count : null;
  } catch {
    return null;
  }
}

// Format gọn lượt xem: 1234 → "1.2K".
export function fmtViews(n) {
  const v = Number(n) || 0;
  if (v >= 1000000) return `${(v / 1000000).toFixed(1)}M`;
  if (v >= 1000) return `${(v / 1000).toFixed(1)}K`;
  return String(v);
}
